// extracted by mini-css-extract-plugin
export var active = "_37-9";
export var backButton = "_37-8";
export var clone = "_37-e";
export var collapseBar = "_37-j";
export var collapseMode = "_37-l";
export var collapsed = "_37-n";
export var dragHandle = "_37-c";
export var dropdownIcon = "_37-g";
export var expanding = "_37-m";
export var hidden = "_37-w";
export var iconContainer = "_37-p";
export var iconSwapper = "_37-v";
export var navItem = "_37-6";
export var navItemIcon = "_37-f";
export var navProfile = "_37-7";
export var notificationCountBadge = "_37-i";
export var notificationDot = "_37-q";
export var optionsContainer = "_37-h";
export var primaryNav = "_37-0";
export var primaryNavDivider = "_37-u";
export var primaryNavResizeHandle = "_37-2";
export var primaryNavResizing = "_37-1";
export var primaryNavTabSection = "_37-t";
export var primaryTab = "_37-o";
export var primaryTabIconBox = "_37-r";
export var secondaryNav = "_37-3";
export var selected = "_37-s";
export var settingsNav = "_37-4";
export var settingsNavItems = "_37-5";
export var show = "_37-d";
export var sideNav = "_37-k";
export var teamItem = "_37-a";
export var userProfileItem = "_37-b";